import React from 'react';

function Modals({ loginModalOpen, demoModalOpen, featureModalOpen, onCloseLoginModal, onCloseDemoModal, onCloseFeatureModal, onOpenLoginModal, onOpenDemoModal }) {
  React.useEffect(() => {
    if (loginModalOpen || demoModalOpen || featureModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [loginModalOpen, demoModalOpen, featureModalOpen]);

  React.useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onCloseLoginModal();
        onCloseDemoModal();
        onCloseFeatureModal();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onCloseLoginModal, onCloseDemoModal, onCloseFeatureModal]);

  const handleLoginSubmit = (event) => {
    event.preventDefault();
    alert('Login functionality will redirect to your school dashboard. This is a demo page.');
    onCloseLoginModal();
  };

  const handleDemoSubmit = (event) => {
    event.preventDefault();
    
    const formData = {
      name: event.target[0].value,
      email: event.target[1].value,
      phone: event.target[2].value,
      school: event.target[3].value,
      timestamp: new Date().toISOString()
    };
    
    const subject = encodeURIComponent('Demo Request - Absolute Vision');
    const body = encodeURIComponent(
      `New Demo Request:\n\n` +
      `Name: ${formData.name}\n` +
      `Email: ${formData.email}\n` +
      `Phone: ${formData.phone}\n` +
      `School: ${formData.school}\n` +
      `Date: ${new Date().toLocaleString()}`
    );
    
    // Open email in new window instead of redirecting
    window.open(`mailto:contact@absolutevision.co.in?subject=${subject}&body=${body}`, '_blank');
    
    alert('✅ Thank you! Your demo request has been sent. Our team will contact you within 24 hours.');
    onCloseDemoModal();
    event.target.reset();
  };

  const handleModalClick = (e, closeModal) => {
    if (e.target.classList.contains('modal')) {
      closeModal();
    }
  };

  return (
    <>
      {/* LOGIN MODAL */}
      <div 
        id="loginModal" 
        className={`modal ${loginModalOpen ? 'active' : ''}`}
        onClick={(e) => handleModalClick(e, onCloseLoginModal)}
      >
        <div className="modal-content">
          <button className="modal-close" onClick={onCloseLoginModal}>×</button>
          <h2 className="modal-title">Welcome Back</h2>
          <p className="modal-subtitle">Login to access your school dashboard</p>
          
          <form className="modal-form" onSubmit={handleLoginSubmit}>
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <input type="email" className="form-input" placeholder="you@school.edu" required />
            </div>
            
            <div className="form-group">
              <label className="form-label">Password</label>
              <input type="password" className="form-input" placeholder="Enter your password" required />
            </div>
            
            <button type="submit" className="form-submit">Sign In</button>
          </form>
          
          <div className="form-footer">
            Don't have an account? <a href="#" onClick={(e) => { e.preventDefault(); onCloseLoginModal(); onOpenDemoModal(); }}>Request Demo</a>
          </div>
        </div>
      </div>

      {/* DEMO BOOKING MODAL */}
      <div 
        id="demoModal" 
        className={`modal ${demoModalOpen ? 'active' : ''}`}
        onClick={(e) => handleModalClick(e, onCloseDemoModal)}
      >
        <div className="modal-content">
          <button className="modal-close" onClick={onCloseDemoModal}>×</button>
          <h2 className="modal-title">Book a Free Demo</h2>
          <p className="modal-subtitle">See Absolute Vision in action! Schedule a personalized demo.</p>
          
          <form className="modal-form" onSubmit={handleDemoSubmit}>
            <div className="form-group">
              <label className="form-label">Full Name</label>
              <input type="text" className="form-input" placeholder="John Doe" required />
            </div>
            
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <input type="email" className="form-input" placeholder="you@school.edu" required />
            </div>
            
            <div className="form-group">
              <label className="form-label">Phone Number</label>
              <input type="tel" className="form-input" placeholder="+91 98765 43210" required />
            </div>
            
            <div className="form-group">
              <label className="form-label">School Name</label>
              <input type="text" className="form-input" placeholder="Your School Name" required />
            </div>
            
            <button type="submit" className="form-submit">Schedule Demo</button>
          </form>
          
          <div className="form-footer">
            Already have an account? <a href="#" onClick={(e) => { e.preventDefault(); onCloseDemoModal(); onOpenLoginModal(); }}>Login</a>
          </div>
        </div>
      </div>

      {/* FEATURE IMAGE MODAL */}
      <div 
        id="featureModal" 
        className={`modal ${featureModalOpen ? 'active' : ''}`}
        onClick={(e) => handleModalClick(e, onCloseFeatureModal)}
      >
        <div className="modal-content" style={{ maxWidth: '900px', padding: '0', overflow: 'hidden' }}>
          <button className="modal-close" onClick={onCloseFeatureModal}>×</button>
          <img src="/friends-school-sunset.png" alt="School Management Feature" style={{ width: '100%', height: 'auto', display: 'block' }} />
        </div>
      </div>
    </>
  );
}

export default Modals;
